import * as Sentry from "@sentry/browser";
import supportedBrowsers from "@Decix.Lib/SupportedBrowsersRegex";
import { CaptureConsole } from "@sentry/integrations";

const scriptTag = document.querySelector("script[data-identifier='sentry']");
const dsn = scriptTag.getAttribute("data-dsn");
const isSupportedBrowser = supportedBrowsers.test(navigator.userAgent);

if (dsn) {
    const release = scriptTag.getAttribute("data-release");
    const environment = scriptTag.getAttribute("data-environment");

    Sentry.init({
        dsn: dsn,
        release: release,
        environment: environment,
        integrations: [
            new CaptureConsole({
                levels: ["error"],
            }),
        ],
        beforeSend: (event) => isSupportedBrowser ? event : null,
        ignoreErrors: [
            // Random plugins/extensions
            "top.GLOBALS",
            // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
            "originalCreateNotification",
            "canvas.contentDocument",
            "MyApp_RemoveAllHighlights",
            "http://tt.epicplay.com",
            "Can't find variable: ZiteReader",
            "jigsaw is not defined",
            "ComboSearch is not defined",
            "http://loading.retry.widdit.com/",
            "atomicFindClose",
            // Facebook borked
            "fb_xd_fragment",
            // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
            // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
            "bmi_SafeAddOnload",
            "EBCallBackMessageReceived",
            // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
            "conduitPage",
            // Generic error code from errors outside the security sandbox
            // You can delete this if using raven.js > 1.0, which ignores these automatically.
            "Script error.",
            // Avast extension error
            "_avast_submit",
        ],
        denyUrls: [
            // Google Adsense
            /pagead\/js/i,
            // Facebook flakiness
            /graph\.facebook\.com/i,
            // Facebook blocked
            /connect\.facebook\.net\/en_US\/all\.js/i,
            // Woopra flakiness
            /eatdifferent\.com\.woopra-ns\.com/i,
            /static\.woopra\.com\/js\/woopra\.js/i,
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
            // Other plugins
            /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
            /webappstoolbarba\.texthelp\.com\//i,
            /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
            // Hupspot forms
            /js-eu1\.hsforms\.net/i
        ],
        tracesSampleRate: 1,
    });
}
